import { render, staticRenderFns } from "./SVGParameter.vue?vue&type=template&id=ba67e282&scoped=true&"
import script from "./SVGParameter.vue?vue&type=script&lang=ts&"
export * from "./SVGParameter.vue?vue&type=script&lang=ts&"
import style0 from "./SVGParameter.vue?vue&type=style&index=0&id=ba67e282&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba67e282",
  null
  
)

export default component.exports